import common from '@/utils/common'

/**
 *
 * 系统状态管理
 *
 * */
const state = {
  lan: '', // 当前语言
  tk: '', // token
  uId: '' // userId
}

// getters
const getters = {}

// 处理方法
const actions = {
  getItemSys ({ commit }, obj) {
    commit('setItemSys', obj)
  }
}

// mutations
const mutations = {
  setItemSys (state, obj) {
    if (obj.lan) {
      state.lan = obj.lan
    }
    if (obj.tk) {
      state.tk = obj.tk
      common.setToken(obj.tk)
    }
    if (obj.uId) {
      state.uId = obj.uId
      common.setUserId(obj.uId)
    }
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/sys.js